export default __webpack_public_path__ + "static/media/Bg-10.2c0658b6.png";